import moment from 'moment';
import React from 'react';
import {DateInput} from '../date/date';

export function BirthDateInput({ value, onChange }) {

	return (
		<DateInput
			minYear={1900}
			maxYear={new Date().getFullYear()}
			minDate='01/01/1900'
			maxDate={moment()}
			value={value}
			onChange={onChange}
		/>
	)
}
